export const calculateDiffObject = (barA, barB) =>
	Object
		.keys(barB)
		.map(key => ({ key, value: barB[key] }))	
		.reduce(( diff, { key, value }) => {
			if ( diff[key] != null ) {
				const difference = diff[key] - value;
				diff[key] = difference > 0 ? difference : 0;
			}
			return diff;
		}, { ...barA });



// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/fitness/providers/NoteSizePartialFitness/calculateDiffObject.js